/* eslint-disable @typescript-eslint/no-explicit-any */
export const isDev = import.meta.env.DEV;
import packageJson from "../../package.json";

export const baseUrl = import.meta.env.DEV
  ? "https://mainbackend.woogiu.com/woogi/0.1/actor/cgi.php"
  : "/woogi/0.1/actor/cgi.php";

export const top = window.top as any;

export const gms: any = top?.gms;
export const gameCanvas = top?.getCanvas?.();
export const token = !isDev
  ? gms?.app?.token
  : "fd37947ce631a6177ba17f486ecb00fa";

export const parseItemImage = (url: string | undefined) => {
  if (!isDev) return url;

  return url
    ? url.includes("mainbackend")
      ? url
      : "//mainbackend.woogiu.com/" + url
    : "";
};

export const logger = (...rest: any[]) => {
  console.log("🏃‍♂️", packageJson.name, ":", ...rest);
};

export const closeUI = () => {
  if (import.meta.env.PROD) {
    gms?.ui?.hide(window.name);
  }
};

export const clearCacheAndBuildToken = async () => {
  delete_cookie("HAT_parent_token");
  delete_cookie("parent_code");
};

export function set_cookie(name: string, value: string) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; Path=/;";
}

export function delete_cookie(name: string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

/**
 * Retrieves the value of a cookie by name.
 * @param {string} name the name of the cookie
 * @returns {string | null} the value of the cookie, or null if the cookie does not exist
 */

export function get_cookie_value(name: string) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const getCountryCode = () => {
  const countryCode = get_cookie_value("country_code");

  return countryCode;
};
